export const categories = [
  {
    id: 'shoes',
    name: 'Buty',
    nameEn: 'Shoes',
    icon: 'ri-footprint-line',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
  },
  {
    id: 'hoodies',
    name: 'Bluzy/Swetry',
    nameEn: 'Hoodies/Sweaters',
    icon: 'ri-t-shirt-line',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
  },
  {
    id: 'tshirts',
    name: 'Koszulki',
    nameEn: 'T-Shirts',
    icon: 'ri-t-shirt-air-line',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
  },
  {
    id: 'jackets',
    name: 'Kurtki',
    nameEn: 'Jackets',
    icon: 'ri-shirt-line',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
  },
  {
    id: 'pants',
    name: 'Spodnie/Szorty',
    nameEn: 'Pants/Shorts',
    icon: 'ri-pantone-line',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
  },
  {
    id: 'headwear',
    name: 'Nakrycia głowy',
    nameEn: 'Headwear',
    icon: 'ri-user-smile-line',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
  },
  {
    id: 'sets',
    name: 'Zestawy',
    nameEn: 'Sets',
    icon: 'ri-stack-line',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
  },
  {
    id: 'underwear',
    name: 'Bielizna',
    nameEn: 'Underwear/Underpants',
    icon: 'ri-shirt-line',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
  },
  {
    id: 'jersey',
    name: 'Koszulki sportowe',
    nameEn: 'Jersey',
    icon: 'ri-archive-line',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
  },
  {
    id: 'accessories',
    name: 'Akcesoria',
    nameEn: 'Accessories',
    icon: 'ri-glasses-line',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
  },
  {
    id: 'bags',
    name: 'Torby',
    nameEn: 'Bags',
    icon: 'ri-briefcase-line',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
  },
  {
    id: 'belts',
    name: 'Paski',
    nameEn: 'Belts',
    icon: 'ri-link',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
  },
  {
    id: 'perfumes',
    name: 'Perfumy',
    nameEn: 'Perfumes',
    icon: 'ri-contrast-drop-line',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
  },
  {
    id: 'other',
    name: 'Inne produkty',
    nameEn: 'Other Stuff',
    icon: 'ri-more-line',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
  },
];